import { Form, Formik, FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';

import { QuestionWrapper } from '../../components';
import { TextareaField, CheckBoxField } from '../../fields';
import { MeetingFormValues } from '../../models/Forms';
import { I18nNameSpaces } from '../../services/i18n';
import { makeMeetingSchema } from './schema';

interface Props {
  initialValues?: Partial<MeetingFormValues>;
  bindSubmit?: (formik: FormikProps<MeetingFormValues>) => void;
  onSubmit: (values: MeetingFormValues) => void;
}

export default function MeetingForm({ onSubmit, initialValues, bindSubmit }: Props) {
  const { t } = useTranslation(I18nNameSpaces.Forms);
  const schema = makeMeetingSchema();

  function handleOnSubmit(values: MeetingFormValues) {
    onSubmit && onSubmit(values);
  }

  function renderForm(formik: FormikProps<MeetingFormValues>) {
    if (bindSubmit) {
      bindSubmit(formik);
    }
    return (
      <div className="meeting-form">
        <Form>
          <QuestionWrapper>
            <QuestionWrapper.Divider>
              <QuestionWrapper.Title>{t('meetingForm.subTitle')}</QuestionWrapper.Title>
            </QuestionWrapper.Divider>
            <QuestionWrapper.Divider>
              <CheckBoxField name="a" label={t('meetingForm.a')} />
              <CheckBoxField name="b" label={t('meetingForm.b')} />
            </QuestionWrapper.Divider>
            <QuestionWrapper.Divider>
              <QuestionWrapper.Title>{t('meetingForm.note')}</QuestionWrapper.Title>
              <TextareaField name="note" />
            </QuestionWrapper.Divider>
          </QuestionWrapper>
        </Form>
      </div>
    );
  }

  return (
    <Formik
      initialValues={{
        a: initialValues?.a ?? false,
        b: initialValues?.b ?? false,
        note: initialValues?.note ?? '',
      }}
      onSubmit={handleOnSubmit}
      validationSchema={schema}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {renderForm}
    </Formik>
  );
}
